import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-pitch',
  templateUrl: './icon-pitch.component.html',
  styleUrls: ['./icon-pitch.component.scss']
})
export class IconPitchComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
